import React from "react";
import { RenderLeafProps } from "slate-react";
import { CustomText } from "../types";

// Define animated text gradient classes - Copied from Element.tsx for consistency
const loadingEffectClasses =
  "animate-[text-gradient_1s_linear_infinite] animate-pulse bg-gradient-to-r from-teal-500 via-purple-500 to-orange-500 bg-clip-text text-transparent";

export const Leaf = ({ attributes, children, leaf }: RenderLeafProps) => {
  const text = leaf as CustomText;
  let className = "";

  // Check if this leaf part should have the loading effect (added by decorate)
  const isLoading = !!(leaf as CustomText & { loading?: boolean }).loading;

  switch (text.size) {
    case "sm":
      className = "text-sm";
      break;
    case "md":
      className = "text-base";
      break;
    case "lg":
      className = "text-lg";
      break;
    case "xl":
      className = "text-xl";
      break;
  }

  let element = children;
  if (text.bold) {
    element = <strong> {element} </strong>;
  }
  if (text.italic) {
    element = <em> {element} </em>;
  }
  if (text.underline) {
    element = <u> {element} </u>;
  }

  // Apply loading styles conditionally
  const finalClassName = isLoading ? loadingEffectClasses : className;

  return (
    <span {...attributes} className={finalClassName}>
      {element}
    </span>
  );
};
